<template>
  <div class="submit2">
    <el-form>
      <el-form-item>
        <div class="label">上传故障照片/视频</div>
        <div class="faultPic">


          <el-upload
            class="fault"
            action="#"
            accept="video/*|image/*"
            list-type="picture-card"
            :on-change="fault"
            :http-request="faultUpload"
          >
            <!-- <i class="el-icon-plus"></i> -->
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item>
        <div class="submitBtn">
          <el-button class="subBtn" @click="submit">立刻提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  components: {},
  props: {
    baseFormData: {
      type: Object,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      files: {
        fileList1: [],
        fileList2: [],
      },
      formData: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  watch: {
  },

  methods: {
    init() {
      this.formData = this.baseFormData;
    },
    sn(file) {
      this.files.fileList1.push(file.raw);
    },

    // snUpload() {
    //   requpload({ file: this.files.fileList1 })
    //     .then((res) => {
    //       const imgs = res.data.data;
    //           let str = '';
    //           for (let i = 0; i < imgs.length; i++) {
    //             str = str + imgs[i].url + ',';
    //           }
    //           this.formData.sn_upload = str;
    //     })
    //     .catch((error) => console.log(error));

    //   reqsn({ file: this.files.fileList1 })
    //     .then((res) => {
    //       const imgs = res.data.data;
    //       if (!imgs) {
    //         return;
    //       }
    //       let str = "";
    //       for (let i = 0; i < imgs.length; i++) {
    //         str = str + imgs[i].string + ",";
    //       }
    //       this.formData.sn = str;
    //     })
    //     .catch((error) => console.log(error));
    // },

    fault(file) {
      this.files.fileList2.push(file.raw);
    },

    // 上传文件
    async uploadFile(file) {
      let formData = new FormData();
      formData.append('file[]', file['file']);
      formData.append('file_type_id', 1);
      formData.append('company_id', 0);
      formData.append('dangan', 0);
      formData.append('category_id', '');
      try {
        const response = await axios.post(this.$api.stUpload, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        let res = response.data;
        if (res.code !== 1) {
          this.$toast.fail('文件上传失败');
          return;
        }
        return response;
      } catch (error) {
        console.error('上传失败:', error);
      }
      
    },
    faultUpload(file) {
      let promise = this.uploadFile(file);
      console.log('promise', promise);
      promise.then((fileRes) => {
        if (fileRes) {
          let data = fileRes['data']['data'];
          let fileList = this.formData.fujian ?  this.formData.fujian : [];
          fileList.push(...data.map((item) => { return item.url }));
          this.formData.fujian = fileList;
        }
      });
    },

    submit() {
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData.fujian =  this.formData.fujian ? this.formData.fujian.join(',') : '';
      this.$emit("submit", formData);
    },


    prev(){
      this.$emit("prev", this.formData);
    }
  },
};
</script>


<style lang="scss" scoped>
.submit2 {
  .head {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    background: rgba(255, 255, 255, 1);
    padding: 0 10px;
    .el-icon {
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
    }
  }
  .el-form {
    .el-form-item {
      margin: 0;
      .label {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
      }
      .inp {
        height:40px;
      }
      .snPic {
        width: 100%;
        background: rgba(255, 255, 255, 1);
        padding: 12px 10px;
        .picture {
          width: 100%;
          height: 72px;
          margin-bottom: 12px;
          overflow: auto;
          :deep(.el-upload) {
            width: 84px;
            height: 60px;
          }
          :deep(.el-upload-list__item) {
            width: 84px;
            height: 60px;
          }
          :deep(.el-upload-list__item-thumbnail) {
            width: 84px;
            height: 60px;
          }
          :deep(.el-upload-list__item-actions) {
            display: none;
          }
        }
      }
      .faultPic {
        width: 100%;
        height: 250px;
        background: rgba(255, 255, 255, 1);
        padding: 12px 10px;
        :deep(.el-upload) {
          width: 84px;
          height: 60px;
        }
        :deep(.el-upload-list__item) {
          width: 84px;
          height: 60px;
        }
        :deep(.el-upload-list__item-thumbnail) {
          width: 84px;
          height: 60px;
        }
        :deep(.el-upload-list__item-actions) {
          display: none;
        }
      }
    }
    .submitBtn {
      width: 100%;
      height:80px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      left: 0px;
      bottom: 0;
      .subBtn {
        width: 348px;
        height: 48px;
        background: rgba(255, 87, 51, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        border-radius: 15px;
      }
    }
  }
}

.el-upload-list > .el-upload-list__item {
}
</style>
